import React from 'react';

function StarIcon({ size }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_3993_33047)" opacity="0.7">
        <path
          fill="#FDCB2C"
          d="M19.467 23.315L12 17.827l-7.467 5.488L7.4 14.452-.063 9h9.214l2.85-8.878L14.848 9h9.213L16.6 14.452l2.867 8.863z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_3993_33047">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default StarIcon;
